import {
  getList,
  LeoUUID,
} from "@surya-digital/leo-ts-types";
import { TableFilter, TableFilterDTO, TableFilterEnums } from "../types/tableFilter";


export namespace BOUsersSelection {
  export interface AllRowsSelectedDTO {
    case: string;
    filters: TableFilterDTO[];
  }
  
  export class AllRowsSelected {
    readonly isBOUsersSelectionAllRowsSelected: boolean = true;
  
    readonly filters: TableFilter[];
  
    static readonly constraints = {
      "filters": {
        "maxSize": 5,
      }
    }
  
    constructor(
    filters: TableFilter[]
    ) {
      AllRowsSelected.validateFilters(filters);
      this.filters = filters;
    }
  
    static fromDTO(dto: AllRowsSelectedDTO): AllRowsSelected {
      const filters = getList<TableFilterDTO, TableFilter>(
        dto,
        "filters",
        TableFilter.fromDTO,
        InvalidBOUsersSelectionAllRowsSelectedFiltersError
      );
      return new AllRowsSelected(
        filters
      );
    }
  
    toDTO(): AllRowsSelectedDTO {
      const dto: AllRowsSelectedDTO = {
        case: "ALL_ROWS_SELECTED",
          filters: this.filters.map((e: TableFilter) => { return e.toDTO() })
      };
      return dto;
    }
    private static validateFilters = (filters: TableFilter[]): void => {
      if(filters.length > 5) {
        throw new InvalidBOUsersSelectionAllRowsSelectedFiltersMaxSizeError(
          5,
          `Attribute filters is too long. Size is ${filters.length}. Max size is 5.`
        );
      }
    }
    
  }
  
  AllRowsSelected.prototype.toString = function toString(): string {
    return `BOUsersSelection.ALL_ROWS_SELECTED(filters='${this.filters}')`;
  };
  
  export interface SomeRowsSelectedDTO {
    case: string;
    selectedBOUserIds: string[];
  }
  
  export class SomeRowsSelected {
    readonly isBOUsersSelectionSomeRowsSelected: boolean = true;
  
    readonly selectedBOUserIds: LeoUUID[];
  
  
    constructor(
    selectedBOUserIds: LeoUUID[]
    ) {
      this.selectedBOUserIds = selectedBOUserIds;
    }
  
    static fromDTO(dto: SomeRowsSelectedDTO): SomeRowsSelected {
      const selectedBOUserIds = getList<string, LeoUUID>(
        dto,
        "selectedBOUserIds",
        (e: string) => new LeoUUID(e),
        InvalidBOUsersSelectionSomeRowsSelectedSelectedBoUserIdsError
      );
      return new SomeRowsSelected(
        selectedBOUserIds
      );
    }
  
    toDTO(): SomeRowsSelectedDTO {
      const dto: SomeRowsSelectedDTO = {
        case: "SOME_ROWS_SELECTED",
          selectedBOUserIds: this.selectedBOUserIds.map((e: LeoUUID) => { return e.toDTO(); })
      };
      return dto;
    }
    }
  
  SomeRowsSelected.prototype.toString = function toString(): string {
    return `BOUsersSelection.SOME_ROWS_SELECTED(selectedBOUserIds='${this.selectedBOUserIds}')`;
  };
  

  export type BOUsersSelection = AllRowsSelected | SomeRowsSelected;

  export type BOUsersSelectionDTO = AllRowsSelectedDTO | SomeRowsSelectedDTO;

  export const fromDTO = (dto: BOUsersSelectionDTO): BOUsersSelection => {
    switch (dto.case) {
      case "ALL_ROWS_SELECTED":
          return AllRowsSelected.fromDTO(dto as AllRowsSelectedDTO);
      case "SOME_ROWS_SELECTED":
          return SomeRowsSelected.fromDTO(dto as SomeRowsSelectedDTO);
      default:
        throw new InvalidBOUsersSelectionError(
            `Case ${dto.case} is not valid case of BOUsersSelection.`
        );
    }
  };
}

export class InvalidBOUsersSelectionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUsersSelectionError";
  }
}
export class InvalidBOUsersSelectionAllRowsSelectedError extends InvalidBOUsersSelectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUsersSelectionAllRowsSelectedError";
  }
}

export class InvalidBOUsersSelectionAllRowsSelectedFiltersError extends InvalidBOUsersSelectionAllRowsSelectedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUsersSelectionAllRowsSelectedFiltersError";
  }
}

export class InvalidBOUsersSelectionAllRowsSelectedFiltersMaxSizeError extends InvalidBOUsersSelectionAllRowsSelectedFiltersError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUsersSelectionAllRowsSelectedFiltersMaxSizeError";
  }
}

export class InvalidBOUsersSelectionSomeRowsSelectedError extends InvalidBOUsersSelectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUsersSelectionSomeRowsSelectedError";
  }
}

export class InvalidBOUsersSelectionSomeRowsSelectedSelectedBoUserIdsError extends InvalidBOUsersSelectionSomeRowsSelectedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUsersSelectionSomeRowsSelectedSelectedBoUserIdsError";
  }
}
